'use client';

import React, { useMemo } from 'react';
import { markerConstant } from './marker-constant';

interface ClusterContentProps {
  count: number;
  sizeAsText?: string;
}

const ClusterContentInner: React.FC<ClusterContentProps> = ({ count, sizeAsText }) => {
  // Use the same sizing logic as FeaturesClusterMarker
  const markerOption = useMemo(() => {
    if (count < 10) return markerConstant[0];
    if (count < 25) return markerConstant[1];
    if (count < 50) return markerConstant[2];
    if (count < 100) return markerConstant[3];
    return markerConstant[4];
  }, [count]);

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    width: `${markerOption.size}px`,
    height: `${markerOption.size}px`,
    cursor: 'pointer',
    display: 'inline-block',
  };

  const textStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'white',
    fontWeight: 'bold',
    fontSize: count > 50 ? '16px' : '14px',
    textShadow: '1px 1px 2px rgba(0,0,0,0.8)',
    zIndex: 2,
  };

  return (
    <div className="cluster-marker" style={containerStyle}>
      <img src={markerOption.image} alt="Cluster marker" width={markerOption.size} height={markerOption.size} />
      <div style={textStyle}>{sizeAsText ?? String(count)}</div>
    </div>
  );
};

export const ClusterContent = React.memo(ClusterContentInner);
